import { Component } from "@angular/core";

import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: 'count-link-renderer',
    templateUrl: './count-link-renderer.component.html',
    standalone: false
})
export class CountLinkRendererComponent implements ICellRendererAngularComp {
    public count: number;

    initilize(params: ICellRendererParams) {
        this.count = params.getValue();
    }

    // called on init
    agInit(params: any): void {
        this.initilize(params);
    }

    // called when the cell is refreshed
    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

}
